<template>
  <div class="mt-3" v-if="isLoggedIn">
    <h1 class="mb-3">
      {{ $t('tra.t') }}
    </h1>
    <b-card class="mt-3" header-tag="nav" body-class="p-2 p-sm-4">
      <template #header>
        <b-nav card-header tabs>
          <b-nav-item :to="`/transactions/accounts_`+$route.meta.m" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-calculator v-if="!isXs" v-bind="iH" /> {{ $t('tra.hacc') }}
          </b-nav-item>
          <b-nav-item :to="`/transactions/invoices_`+$route.meta.m" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-receipt v-if="!isXs" v-bind="iH" /> {{ $t('tra.hinv') }}
          </b-nav-item>
        </b-nav>
      </template>
      <router-view name="top" />
    </b-card>
    <h3 class="mt-3">
      {{ $t('tra.t1') }}
    </h3>
    <b-card class="mt-3" header-tag="nav" body-class="p-2 p-sm-4">
      <template #header>
        <b-nav card-header tabs>
          <b-nav-item :to="`/transactions/`+$route.meta.t+`_new`" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-credit-card v-if="!isXs" v-bind="iH" /> {{ $t('tra.hne') }}
          </b-nav-item>
          <b-nav-item :to="`/transactions/`+$route.meta.t+`_current`" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-caret-right-fill v-if="!isXs" v-bind="iH" /> {{ $t('tra.hcu') }}
          </b-nav-item>
          <b-nav-item :to="`/transactions/`+$route.meta.t+`_previous`" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-caret-left-fill v-if="!isXs" v-bind="iH" /> {{ $t('tra.hpr') }}
          </b-nav-item>
          <b-nav-item :to="`/transactions/`+$route.meta.t+`_res`" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-calendar-check v-if="!isXs" v-bind="iH" /> {{ $t(isUser ? 'tra.hru' : 'tra.hrc') }}
          </b-nav-item>
          <b-nav-item :to="`/transactions/`+$route.meta.t+`_extra`" link-classes="px-2 px-sm-3" exact exact-active-class="active">
            <b-icon-credit-card v-if="!isXs" v-bind="iH" /> {{ $t(isUser ? 'tra.hxu' : 'tra.hxc') }}
          </b-nav-item>
        </b-nav>
      </template>
      <router-view name="mid" />
    </b-card>
  </div>
</template>

<script>
import { BIconCaretRightFill, BIconCaretLeftFill, BIconCreditCard, BIconCalendarCheck, BIconCalculator, BIconReceipt } from 'bootstrap-vue';

export default {
  computed: {
    isLoggedIn() {
      return this.$store.state.oLogin.isLoggedIn;
    },
    isUser() {
      return this.$store.state.oLogin.isUser;
    },
    iH() {
      return this.$store.getters.iH;
    },
    isXs() {
      return this.$store.getters.isXs;
    },
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.replace('/').catch(() => {});
    }
  },
  components: {
    BIconCaretRightFill,
    BIconCreditCard,
    BIconCaretLeftFill,
    BIconCalendarCheck,
    BIconCalculator,
    BIconReceipt,
  },
}
</script>
